import {race, take, delay, call, put, select, takeEvery} from 'redux-saga/effects';
import {mapValues, difference, union, api, map, cookies, keys} from 'helpers';
import {changesByType} from 'store/server';
import {notify, notified, read} from '.';

export function* serverRead() {
  let invalidated;

  yield takeEvery(['SERVER_READ', 'SERVER_QUERY'], function*() {
    invalidated = true;
  });

  while (true) {
    try {
      //wait for 5 minutes or signal (whatever comes first)
      const event = yield race({
        'launch': take(['APP_LAUNCH', 'SESSION_ONLINE']),
        'signal': take('SERVER_READ'),
        'check-up': delay(5*60*1000),
      });

      invalidated = false;

      if (!cookies.get('token')) {
        return;
      }

      yield put({
        type: 'SERVER_DATA_READING'
      });

      // read data now
      const response = yield call(api, '/get/', {
        event: keys(event).pop(),
        lastSyncTime: yield select(state => state.server.lastSyncTime),
        timezoneOffset: new Date().getTimezoneOffset()*60000*-1, //pass offset in ms (the negative sign is on purpose here)
      });

      //if there was a signal to read data from the server or an update to the server
      //quit and retry later
      if (invalidated) {
        yield delay(5000);
        yield put(read());
        continue;
      }

      const changes = yield select(changesByType);

      const existingElementIds = mapValues(response.existingElementIds, (ids, type) => {
        ids = union(ids, map(changes['create_' + type], 'payload.serverId')); //keep IDs that were recently added
        return difference(ids, map(changes['delete_' + type], 'payload.serverId')); //remove IDs that were recently deleted
      });

      yield put(notify(response, existingElementIds));

      yield put(notified());

    } catch (error) {
      yield put({
        type: 'SERVER_ERROR',
        errorMessage: 'Failed to read data from the server.',
        error,
      });
    }
  }
}
